import './styles/global.scss';
import { createApp } from 'vue';

import App from './App.vue';
import { sentry } from './modules/sentry.js';

/* eslint-disable no-unused-vars */
import * as registerComponents from './modules/registerComponents.js';
import * as registerIcons from './modules/registerIcons.js';
/* eslint-enable no-unused-vars */

const app = createApp(App);

// Initialize sentry
sentry(app);

app.mount('#app');
